export enum LoginFormState { 
    CREDS = 'CREDS',
    TOTP_CODE = 'TOTP_CODE',
    PROGRESS = 'PROGRESS',
}